export const getAuthItem = (key) =>
  sessionStorage.getItem(key) || localStorage.getItem(key)